import React, { useEffect, useState } from 'react';
import PageHeader from 'components/molecules/PageHeader';
import Alert from 'components/atoms/Alert';
import AppTable from 'components/organisms/app-table';
import TableDataSpan from 'components/organisms/app-table/TableDataSpan';
import CopyText from 'components/atoms/CopyText';
import moment from 'moment';
import ViewTransaction from '../ModalComponents/ViewTransactionModal';
import { BASE_URL, getRequest, loggedUser_baseURL } from 'services/http';
import { connect, useSelector } from 'react-redux';
import refreshicon from '../../../assets/svg/refresh.svg';
import useDebounce from 'components/molecules/useDebounce';

const Transactions = (props) => {
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [totalTransactions, setTotalTransactions] = useState<any>();
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [pageNum, setPageNum] = useState(null);
  const [recordsPerPage] = useState(10);
  const [selectPaymentChannel, setSelectPaymentChannel] = useState('');
  const [selectedTransactionStatus, setSelectedTransactionStatus] = useState('');
  const [selectedSearchKey, setSelectedSearchKey] = useState('');
  const [query, setQuery] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateValid, setDateValid] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const debouncedQuery = useDebounce(query, 800);

  const searchParams = ["paymentReference", "customerName"];

  useEffect(() => {
    const currentDate = moment().endOf('day'); // Adjust to 09:00:00
    const oneMonthAgo = moment().subtract(1, 'months').startOf('day'); // Adjust to 09:00:00

    const start = oneMonthAgo.format('YYYY-MM-DD HH:mm:ss');
    const end = currentDate.format('YYYY-MM-DD HH:mm:ss');

    setStartDate(start);
    setEndDate(end);
  }, [refresh]);

  const transactionStatusList = [
    { label: "Successful", value: "COMPLETED" },
    { label: "Failed", value: "FAILED" },
    { label: "Pending", value: "PENDING" }
  ];

  const countries = useSelector((state: any) => state.app.countries);
  const businessCountry = countries?.find((c) => c.name?.toLowerCase() === props.userAuthRes.country?.toLowerCase());

  const paymentChannelList = businessCountry?.name === "NIGERIA"
    ? businessCountry?.defaultPaymentOptions.filter(channel => channel.name !== 'MOMO').map((op: any) => ({
      label: op?.code,
      value: op?.code
    })) || []

    : businessCountry?.defaultPaymentOptions.map((op: any) => ({
      label: op?.code,
      value: op?.code
    })) || []

  const FilterData = [
    { titleText: 'Payment Channel', filters: paymentChannelList, selected: selectPaymentChannel, setSelected: setSelectPaymentChannel },
    // { titleText: 'Transaction Status', filters: transactionStatusList, selected: selectedTransactionStatus, setSelected: setSelectedTransactionStatus },
  ];

  const btnActionData = [
    {
      btnText: 'Refresh', btnStyle: `bg-SecondaryAccent5 text-DarkBg3 !text-sm !flex-row`, handleClick: () => {
        setLoading(true);
        setRefresh(prevState => !prevState)
        setTimeout(() => setLoading(false), 1000);
      }, btnImg: refreshicon, btnImgStyle: loading && '!animate-fullRoll'
    }
  ];


  const urlParam = `size=${recordsPerPage}&page=${pageNum === null ? 1 : pageNum}&startDate=${startDate}&endDate=${endDate}&transactionStatus=COMPLETED`;

  const default_url = `${BASE_URL + loggedUser_baseURL + `partner/${props.businessId}/transactions`}?${urlParam}`;

  // Adjust the URL based on debouncedQuery and other filters
  const main_url = debouncedQuery !== '' && dateValid
    ? `${default_url}&${selectedSearchKey}=${debouncedQuery}`
    : selectPaymentChannel !== '' && dateValid
      ? `${default_url}&paymentChannel=${selectPaymentChannel}`
      : selectedTransactionStatus !== '' && dateValid
        ? `${default_url}&transactionStatus=${selectedTransactionStatus}`
        : selectPaymentChannel !== '' && selectedTransactionStatus !== '' && dateValid
          ? `${default_url}&paymentChannel=${selectPaymentChannel}&transactionStatus=${selectedTransactionStatus}`
          : debouncedQuery === '' && selectPaymentChannel === '' && selectedTransactionStatus === '' && dateValid
            ? default_url
            : `${default_url}&${selectedSearchKey}=${debouncedQuery}&paymentChannel=${selectPaymentChannel}&transactionStatus=${selectedTransactionStatus}`;

  const getTransactions = async () => {
    setLoading(true);
    const res = await getRequest(main_url, {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${props.bearerToken}`,
      "Public-Key": `${props.publicKey}`
    });
    // const res = {
    //   data: {
    //     "status": "SUCCESS",
    //     "message": "TransactionHistory fetched successfully",
    //     "errorMessage": null,
    //     "responseCode": "00",
    //     "data": [
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Jason Global Ventures",
    //         "businessId": "00000448",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Jayden Signatures",
    //         "businessId": "00000449",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Sols Furniture",
    //         "businessId": "00000450",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Johnny and Sons",
    //         "businessId": "00000451",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Damina Enterprises",
    //         "businessId": "00000453",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Jameson Nig Ltd",
    //         "businessId": "00000454",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Willy Nig Ltd",
    //         "businessId": "00000455",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Don Dimon Nig Ltd",
    //         "businessId": "00000456",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Marcellinus Nig Ltd",
    //         "businessId": "00000457",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Marcoellinus Nig Ltd",
    //         "businessId": "00000458",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Altenwerth - Rau",
    //         "businessId": "00000459",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Nienow LLC",
    //         "businessId": "00000460",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Weber - Reichel",
    //         "businessId": "00000461",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Price, Hilpert and Ebert",
    //         "businessId": "00000462",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Blick - Johnston",
    //         "businessId": "00000463",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Kub, Weissnat and Sauer",
    //         "businessId": "00000464",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Marvels and Treats Nig Ltd",
    //         "businessId": "00000465",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Hilll, White and Huel",
    //         "businessId": "00000466",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Koelpin Group",
    //         "businessId": "00000467",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Sunny Star Inc",
    //         "businessId": "00000469",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Othman Ventures",
    //         "businessId": "00000471",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Sure Cakes",
    //         "businessId": "00000472",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Don Domino",
    //         "businessId": "00000478",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Willy Enterprises",
    //         "businessId": "00000479",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Glova Spar",
    //         "businessId": "00000481",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Fraser Global Resources",
    //         "businessId": "00000489",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Austin Global Resources",
    //         "businessId": "00000490",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       },
    //       {
    //         "totalAmountTransacted": 0,
    //         "totalTransactionCount": 0,
    //         "totalCommissions": 0,
    //         "businessName": "Daci",
    //         "businessId": "00000491",
    //         "businessEmail": null,
    //         "businessCountry": "Nigeria",
    //         "paymentChannels": [],
    //         "businessCurrency": "NGN"
    //       }
    //     ],
    //     "pageNumber": 1,
    //     "pageSize": 50,
    //     "totalPages": 1,
    //     "totalElements": 28
    //   }
    // }

    if (res?.data.status === 'SUCCESS') {
      //@ts-ignore
      setTransactions(res?.data.data);
      setTotalTransactions(res?.data.totalElements);

      setTimeout(() => setLoading(false), 1500);
    } else {
      setLoading(false);
    }
  };

  //   useEffect(() => {
  //     if (startDate !== '' && endDate !== '' && dateValid) getTransactions();
  // }, [startDate, endDate, refresh]);

  useEffect(() => {
    if (debouncedQuery !== '' || debouncedQuery === '' || selectPaymentChannel !== '' || selectedTransactionStatus !== '' || dateValid) {
      setTimeout(() => {
        if (startDate !== '' && endDate !== '' && dateValid) getTransactions();
      }, 800);
    }
  }, [debouncedQuery, selectPaymentChannel, selectedTransactionStatus, dateValid, endDate, pageNum]);

  const viewTransaction = (id) => {
    setShowModal(prevState => !prevState);
    const transactionFilter = transactions.filter((item: any) => item.paymentReference === id);
    const transactionItem = transactionFilter[0];
    setTransactionDetails(transactionItem);
  };

  const getCurrentPage = (pageNumber) => {
    setPageNum(pageNumber);
  };

  const columns = [
    {
      label: 'Date',
      render: (data) => <TableDataSpan
        onClick={() => viewTransaction(data.paymentReference)}
        handleMouseEnter={() => { }}
        text={moment(data.date).format("MMM DD, YYYY - LTS")}
        additionalClass='text-opacity-70 text-xs cursor-pointer'
      />
    },
    {
      label: 'Amount',
      render: (data) => <TableDataSpan
        onClick={() => viewTransaction(data.paymentReference)}
        handleMouseEnter={() => { }}
        additionalClass='text-opacity-70 text-xs cursor-pointer'
      >
        <div className='flex items-center justify-start gap-2'>
          <span>{data.currency + " " + (Intl.NumberFormat().format(data.amount))}</span>
        </div>
      </TableDataSpan>
    },
    {
      label: 'Commission Amount',
      render: (data) => <TableDataSpan
        onClick={() => viewTransaction(data.paymentReference)}
        handleMouseEnter={() => { }}
        additionalClass='text-opacity-70 text-xs cursor-pointer'
      >
        <div className='flex items-center justify-start gap-2'>
          <span>{data.currency + " " + (Intl.NumberFormat().format(data.commissionAmount))}</span>
        </div>
      </TableDataSpan>
    },
    {
      label: 'Payment Reference',
      render: (data) => <TableDataSpan
        handleMouseEnter={() => { }}
        additionalClass="cursor-default"
      >
        <CopyText
          text={data.paymentReference}
          textStyle="text-opacity-70 text-xs mr-2 inline-block item-center"
          mssgStyle='-right-3 -top-[18px]'
          imgStyle="w-4 h-4"
        />
      </TableDataSpan>
    },
    {
      label: 'Payment Channel',
      render: (data) => <TableDataSpan
        onClick={() => viewTransaction(data.paymentReference)}
        handleMouseEnter={() => { }}
        text={data.paymentChannel}
        additionalClass='text-opacity-70 text-xs cursor-pointer'
      />
    },
    {
      label: 'Business Name',
      render: (data) => <TableDataSpan
        onClick={() => viewTransaction(data.paymentReference)}
        handleMouseEnter={() => { }}
        text={data.customerName}
        additionalClass='text-opacity-70 text-xs cursor-pointer'
      />
    }
  ];

  return (
    <div className='w-full min-h-[90vh] mobile:min-h-[83vh] h-fit flex flex-col justify-start gap-10'>
      <PageHeader
        pageTitle="Transactions"
        actionData={btnActionData}
        filterData={FilterData}
        dateFilter={true}
        searchInput={query}
        setSearchInput={setQuery}
        searchKey={selectedSearchKey}
        setSearchKey={setSelectedSearchKey}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        dateValid={dateValid}
        setDateValid={setDateValid}
        searchOpts={searchParams}
        loading={loading}
      />
      <AppTable
        columns={columns}
        data={transactions}
        itemsPerPage={recordsPerPage}
        loading={loading}
        errorState={errorState}
        dataLength={totalTransactions}
        getCurrentPage={getCurrentPage}
      />
      {showModal &&
        <ViewTransaction
          toggleModal={() => setShowModal(prevState => !prevState)}
          data={transactionDetails}
        />}
    </div>
  );
};

const mapStateToProps = state => ({
  userAuthRes: state.auth.user_authData,
  businessId: state.auth.user_authData.subPartnerId,
  bearerToken: state.auth.user_authData.token.token,
  publicKey: state.auth.user_authData.live_public_key,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);
